import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getWebPages = async () => {
	const { data } = await axios.get(`${API}/admin/web_pages`);
	return data;
};

export const getWebPage = async (params) => {
	const { data } = await axios.get(`${API}/admin/web_pages/detail`, {
		params,
	});
	return data;
};

export const saveWebPage = async (params) => {
	const { data } = await axios.post(`${API}/admin/web_pages/save`, params);
	return data;
};
